import { Box, Modal } from "components";
import AdvisorIncompleteMFKYC from "./AdvisorIncompleteMFKYC";

const AdvisorIncompleteMFKYCModel = ({
  id,
  open,
  setOpen,
}: {
  id: string;
  open: boolean;
  setOpen: (d: boolean) => void;
}) => {
  return (
    <Modal
      open={open}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box bgcolor={"#fff"} width={"50%"} borderRadius={3}>
        <AdvisorIncompleteMFKYC id={id} setOpen={setOpen} />
      </Box>
    </Modal>
  );
};

export default AdvisorIncompleteMFKYCModel;
